import PainelEmiteRelatorio from './PainelEmiteRelatorio'
import enhance from './PainelEmiteRelatorio.enhancer'

export default enhance(PainelEmiteRelatorio)



// WEBPACK FOOTER //
// ./src/routes/sistema/OkReportDeveloper/components/PainelEmiteRelatorio/index.js